import { render } from "./MaintenanceOSRealizadasTab.vue?vue&type=template&id=1b8bc9ea&scoped=true&ts=true"
import script from "./MaintenanceOSRealizadasTab.vue?vue&type=script&lang=ts"
export * from "./MaintenanceOSRealizadasTab.vue?vue&type=script&lang=ts"

import "./MaintenanceOSRealizadasTab.vue?vue&type=style&index=0&id=1b8bc9ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8bc9ea"]])

export default __exports__